export class Claim {
    id: string = '';    
    quote_id: string = '';    
    quote_meta_id: string = '';    
    fnol_date: string = '';    
    loss_date: string = '';   
    claim_number: string = '';   
    claim_type: number = null;
    status: number = null;
    payment_amount: number = null;   
    notes: string = '';   
    legacy_claim_number: string = '';
    is_claim_made:boolean=false;
    claim_date: string = ''; 
    product_id: string ='';   
}
